import * as React from "react";
import MuiChip from "@material-ui/core/Chip";
import type { UiBaseProps } from "../uiProps.utils";

export enum ChipSize {
  SMALL = "small",
  MEDIUM = "medium",
}

export enum ChipColor {
  DEFAULT = "default",
  PRIMARY = "primary",
}

export type ChipProps = Omit<UiBaseProps, "children"> & {
  label: React.ReactNode;
  size?: ChipSize;
  color?: ChipColor;
};

// A small rounded label. Its background beats a Tailwind bg-* class, so set custom colours through `style`.
export const Chip = (props: ChipProps) => <MuiChip {...props} />;
